/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Endpoint_Role_CallsInputs */

const en_endpoint_role_calls = /** @type {(inputs: Endpoint_Role_CallsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} calls`)
};

const zh_hans1_endpoint_role_calls = /** @type {(inputs: Endpoint_Role_CallsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 次调用`)
};

const pt_br2_endpoint_role_calls = /** @type {(inputs: Endpoint_Role_CallsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} chamadas`)
};

const es_endpoint_role_calls = /** @type {(inputs: Endpoint_Role_CallsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} llamadas`)
};

const fr_endpoint_role_calls = /** @type {(inputs: Endpoint_Role_CallsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} appels`)
};

const de_endpoint_role_calls = /** @type {(inputs: Endpoint_Role_CallsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Aufrufe`)
};

const ru_endpoint_role_calls = /** @type {(inputs: Endpoint_Role_CallsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вызовов: ${i?.count}`)
};

const it_endpoint_role_calls = /** @type {(inputs: Endpoint_Role_CallsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} chiamate`)
};

/**
* | output |
* | --- |
* | "{count} calls" |
*
* @param {Endpoint_Role_CallsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_role_calls = /** @type {((inputs: Endpoint_Role_CallsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Role_CallsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_role_calls(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_role_calls(inputs)
	if (locale === "es") return es_endpoint_role_calls(inputs)
	if (locale === "fr") return fr_endpoint_role_calls(inputs)
	if (locale === "de") return de_endpoint_role_calls(inputs)
	if (locale === "ru") return ru_endpoint_role_calls(inputs)
	if (locale === "it") return it_endpoint_role_calls(inputs)
	return en_endpoint_role_calls(inputs)
});